const locale = {
  common: {
    save: 'Save',
    cancel: 'Cancel',
    close: 'Close',
    user: 'User',
    account: 'Account',
    signOut: 'Sign out',
    items: 'items',
    yes: 'Yes',
    no: 'No',
  },
  language: {
    label: 'Language',
    shortLabel: 'Language',
    options: {
      'pt-BR': 'Portuguese (Brazil)',
      'en-US': 'English (US)',
      'es-ES': 'Spanish',
    },
  },
  table: {
    empty: 'No records found',
    pagination: '{{start}}-{{end}} of {{total}} items',
  },
  modal: {
    ok: 'Save',
    cancel: 'Cancel',
  },
  sideNav: {
    internalPanel: 'Internal panel',
    userMenu: {
      account: 'Account',
      resetPassword: 'Reset password',
      signOut: 'Sign out',
    },
    sections: {
      overview: 'Overview',
      care: 'Care',
      finance: 'Finance and Insurance',
      admin: 'Administration',
    },
    menu: {
      home: 'Home',
      schedules: 'Appointments',
      schedule: 'Schedule',
      scheduleStatus: 'Schedule status',
      holidays: 'Holidays',
      clients: 'Clients / Vendors',
      odontology: 'Dentistry',
      treatments: 'Estimates / Treatments',
      healthCertificatesControl: 'Certificates control',
      templates: 'Templates',
      healthCertificates: 'Certificates',
      documentsControl: 'Documents control',
      documents: 'Documents',
      prescriptionTemplates: 'Prescription templates',
      prescriptions: 'Prescriptions',
      formsControl: 'Medical records control',
      medicalRecords: 'Medical records',
      procedures: 'Procedures',
      financial: 'Financial',
      financialPlan: 'Chart of accounts',
      paymentMethods: 'Payment methods',
      payableReceivable: 'Accounts payable / receivable',
      cashRegister: 'Cash register',
      guidesControl: 'Guides control',
      guideStatus: 'Guide status',
      guides: 'Guides',
      professionalsControl: 'Professionals control',
      specialties: 'Specialties',
      terminologies: 'Terminologies',
      professionals: 'Professionals',
      covenants: 'Insurance plans',
      usersControl: 'Users control',
      accessGroup: 'Access group',
      users: 'Users',
      salesControl: 'Sales control',
      productSales: 'Product sales',
      salesTracking: 'Sales tracking',
      inventoryControl: 'Inventory control',
      productTypes: 'Product types',
      registerProducts: 'Register products',
      inventoryBalance: 'Inventory balance',
      whatsapp: 'WhatsApp',
      connections: 'Connections',
      monitoring: 'Monitoring',
      relationship: 'Relationship (CRM)',
      crmCampaigns: 'Campaigns',
      crmTemplates: 'Templates',
      crmMessaging: 'Inbox / Messages',
      crcDashboard: 'CRC Dashboard',
      crcContacts: 'Contact Center',
      crcPendencies: 'Pendencies',
      crcReports: 'Reports',
      companyData: 'Company data',
      companies: 'Companies',
    },
  },
  auth: {
    clinicAccess: 'Clinic access',
    title: 'Welcome back',
    subtitle: 'Fill in the details below to access the clinic management.',
    systemEntry: 'Sign in',
    panelDescription:
      'Simpler management for reception, professionals, and managers in one system.',
    support: {
      clinicCodeTitle: 'Clinic code',
      clinicCodeDescription:
        'Identifies the unit or company you are about to access.',
      credentialsTitle: 'Username and password',
      credentialsDescription: 'Use the credentials registered for your team.',
      secureAccessTitle: 'Secure access',
      secureAccessDescription:
        'Your data is linked only to the selected clinic.',
    },
    fields: {
      clinic: 'Clinic code',
      clinicExtra: 'Example: downtown-clinic',
      clinicPlaceholder: 'Enter the clinic code',
      username: 'Username',
      usernamePlaceholder: 'Enter your username',
      password: 'Password',
      passwordPlaceholder: 'Enter your password',
    },
    validation: {
      clinicRequired: 'Please enter the clinic code!',
      usernameRequired: 'Please enter your username!',
      passwordRequired: 'Please enter your password!',
    },
    submit: 'Sign in',
    error: {
      title: 'Authentication error',
      description:
        'Unable to sign in. Check the clinic code, username, and password.',
    },
  },
  resetPassword: {
    title: 'Reset password',
    fields: {
      oldPassword: 'Current password',
      oldPasswordPlaceholder: 'Enter the current password',
      newPassword: 'New password',
      newPasswordPlaceholder: 'Enter the new password',
      confirmPassword: 'Confirm password',
      confirmPasswordPlaceholder: 'Enter the password confirmation',
    },
    feedback: {
      successTitle: 'Password updated',
      successDescription: 'Password updated successfully.',
      errorTitle: 'Error',
      genericError: 'Unable to update the password.',
      requiredFields: 'Fill in all required fields.',
    },
  },
  patientLogin: {
    portalTitle: 'Patient Portal',
    heading: 'Access your account',
    subtitle: 'Track your appointments and information',
    tenant: {
      label: 'Clinic or company code',
      extra:
        'If you did not receive a direct link, enter the clinic or company code.',
      placeholder: 'Example: downtown-clinic',
      required: 'Enter the clinic or company code.',
      missing: 'Enter the clinic or company code to continue.',
    },
    cpf: {
      label: 'Tax ID',
      placeholder: '000.000.000-00',
      required: 'Enter your tax ID',
      invalid: 'Tax ID must have 11 digits',
    },
    birthday: {
      label: 'Birth date',
      placeholder: 'DD/MM/YYYY',
      required: 'Enter your birth date',
    },
    submit: 'Enter portal',
    hint: 'Your data is used only to verify your identity.\nNo password is required.',
    errorDefault: 'Tax ID or birth date is incorrect.',
  },
  publicSchedule: {
    hero: {
      badge: 'Online scheduling',
      title:
        'Your clinic open for new appointments, with no calls and no waiting.',
      description:
        "Choose the professional, the best time, and send your request in minutes. The request goes straight into the clinic's Sigeclin.",
    },
    highlights: {
      flowLabel: 'Flow',
      flowValue: 'Patient chooses the time and sends it alone',
      integrationLabel: 'Integration',
      integrationValue: 'Professionals loaded from the clinic in real time',
      statusLabel: 'Status',
      statusValue: 'Request created with pending confirmation status',
    },
    metrics: {
      professionals: 'Professionals',
      availableSlots: 'Available slots',
      conflicts: 'Day conflicts',
    },
    summary: {
      title: 'Request summary',
      clinic: 'Clinic',
      clinicPlaceholder: 'Enter the code',
      professional: 'Professional',
      professionalPlaceholder: 'Select to see schedule',
      date: 'Date',
      datePlaceholder: 'Choose a date',
      time: 'Time',
      timePlaceholder: 'Set the interval',
    },
    card: {
      title: 'Request appointment',
      subtitle:
        "Fill in your details and select the desired appointment to register the clinic's public scheduling request.",
    },
    clinic: {
      label: 'Clinic code',
      placeholder: 'Example: sigeclin-demo',
      required: 'Enter the clinic code.',
      loadProfessionals: 'Load professionals',
      missingTitle: 'Enter the clinic',
      missingDescription: 'Type the clinic code before continuing.',
      unavailableTitle: 'Clinic not informed',
      unavailableDescription:
        'Enter the clinic code to request your appointment.',
      loadErrorTitle: 'Error loading schedule',
      loadErrorDescription: 'Unable to load professionals from this clinic.',
    },
    noProfessionals: {
      title: 'No professionals available',
      description:
        'This clinic does not yet have active public professionals for scheduling.',
    },
    sections: {
      patientData: '1. Patient details',
      appointment: '2. Appointment selection',
    },
    fields: {
      patientName: 'Full name',
      patientNamePlaceholder: 'Your name',
      patientNameRequired: 'Enter your full name.',
      document: 'Tax ID',
      documentPlaceholder: 'Numbers only or formatted',
      documentRequired: 'Enter your tax ID.',
      birthday: 'Birth date',
      birthdayPlaceholder: 'Select',
      birthdayRequired: 'Enter your birth date.',
      whatsapp: 'WhatsApp',
      whatsappPlaceholder: '(63) 99999-9999',
      whatsappRequired: 'Enter your WhatsApp.',
      whatsappInvalid: 'Enter a valid mobile number with area code.',
      email: 'Email',
      emailPlaceholder: 'you@example.com',
      emailInvalid: 'Enter a valid email.',
      professional: 'Professional',
      professionalPlaceholder: 'Select',
      professionalRequired: 'Select a professional.',
      date: 'Appointment date',
      datePlaceholder: 'Select',
      dateRequired: 'Choose the desired date.',
      startTime: 'Time',
      startTimeRequired: 'Choose the time.',
      duration: 'Expected duration',
      durationRequired: 'Choose the duration.',
      observation: 'Note',
      observationPlaceholder:
        'Reason for the consultation, service preference, or important notes',
      privacy:
        'I authorize the sending of my data for registration and contact regarding this appointment.',
      privacyRequired: 'You need to authorize the data submission.',
    },
    availability: {
      title: 'Professional schedule for the day',
      loading: 'Checking busy time slots...',
      reserved: 'Reserved time',
      empty:
        'No conflicts were found for this date. The displayed times are available.',
      placeholder:
        'Select the professional and date to view already occupied time slots.',
      unavailableSuffix: 'unavailable',
      errorTitle: 'Error checking availability',
      errorDescription: 'Unable to verify the occupied time slots.',
    },
    durationOptions: {
      minutes30: '30 minutes',
      minutes60: '60 minutes',
    },
    warnings: {
      slotUnavailableTitle: 'Time unavailable',
      slotUnavailableDescription:
        'This time conflicts with another appointment for the professional. Choose another interval.',
      slotOccupiedDescription:
        'This time is already occupied for the selected professional.',
    },
    submit: {
      button: 'Request appointment',
      successTitle: 'Appointment requested',
      successDescription: 'Your request was successfully registered.',
      errorTitle: 'Error requesting appointment',
      errorDescription: 'Unable to complete your request.',
    },
    validation: {
      title: 'Availability validation',
      withConflicts:
        "The times marked as unavailable already conflict with the professional's existing schedule.",
      withoutConflicts:
        'The available times already consider the current appointments of the selected professional.',
    },
    success: {
      pill: 'Request registered',
      title: 'Your appointment is now in the clinic schedule.',
      description:
        'The request was successfully saved in Sigeclin. If needed, the clinic may confirm details by WhatsApp or another registered channel.',
      patient: 'Patient',
      professional: 'Professional',
      start: 'Start',
      status: 'Status',
      nextStepTitle: 'Next step',
      nextStepDescription:
        'You can close this page or send another time request if needed.',
      newRequest: 'Create another appointment',
    },
  },
  patientPortal: {
    popupBlocked: 'Unable to open the print screen. Check your pop-up blocker.',
    sessionExpired: 'Session expired. Sign in again.',
    loadError: 'Unable to load the data.',
    retryLogin: 'Sign in again',
    logout: 'Sign out',
    profile: {
      cpf: 'Tax ID',
      birthDate: 'Birth date',
    },
    tabs: {
      schedules: 'Appointments',
      schedulesShort: 'Schedule',
      treatments: 'Treatments',
      treatmentsShort: 'Treat.',
      financials: 'Financial',
      financialsShort: 'Fin.',
      healthCertificates: 'Certificates',
      healthCertificatesShort: 'Cert.',
      prescriptions: 'Prescriptions',
      prescriptionsShort: 'Rx',
      documents: 'Documents',
      documentsShort: 'Docs',
      forms: 'Medical records',
      formsShort: 'Records',
    },
    schedules: {
      empty: 'You do not have future appointments.',
      status: {
        confirmed: 'Confirmed',
        pending: 'Pending',
        cancelled: 'Cancelled',
      },
    },
    financials: {
      empty: 'No financial records found.',
      open: 'Open',
      paid: 'Paid',
      unknown: 'Unknown',
      codePrefix: 'No.',
      dueDate: 'Due date',
      paymentDate: 'Payment',
    },
    healthCertificates: {
      empty: 'No certificate found.',
      title: 'Certificate',
      daysSingle: 'day',
      daysPlural: 'days',
      cid: 'ICD',
      printCopy: 'Print copy',
    },
    documents: {
      empty: 'No document found.',
      prescriptionHeading: 'Prescription',
      documentHeading: 'Document',
      signed: 'Signed',
      printCopy: 'Print copy',
    },
    prescription: {
      digital: 'Digital prescription',
      signed: 'Digitally signed',
      validation: 'Validation',
      signedNotice:
        'This prescription has been signed and has digital validity.',
      medicines: 'Prescribed medicines',
      medicineFallback: 'Medicine {{index}}',
      dosage: 'Dosage',
      frequency: 'Frequency',
      duration: 'Duration',
      instructions: 'Instructions',
      guidelines: 'Guidelines',
      printable: 'This prescription is available for printing.',
    },
    treatments: {
      empty: 'No treatment found.',
      budget: 'Estimate',
      treatment: 'Treatment',
      approved: 'Approved',
      notApproved: 'Not approved',
      professionalMissing: 'Professional not informed',
      total: 'Total',
      progress: 'Treatment progress',
      procedures: 'Procedures',
      procedureFallback: 'Procedure',
      quantity: 'Qty',
      noProcedures: 'No procedures registered.',
      history: 'Evolution history',
      records: 'Records',
      averageRank: 'Average rank',
      lastRank: 'Last rank',
      chartTitle: 'Evolution chart',
      rankDataset: 'Evolution rank',
      rankTooltip: 'Rank',
      observationTooltip: 'Obs.',
      noObservation: 'No observations provided.',
      noHistory: 'No evolution registered for this treatment.',
      status: {
        pending: 'Pending',
        inProgress: 'In progress',
        completed: 'Completed',
        finished: 'Finished',
      },
      timeAt: 'at',
      procedureLabel: 'Procedure',
      signed: 'Signed',
    },
    forms: {
      empty: 'No medical record found.',
      title: 'Medical record',
      code: 'Code',
      signed: 'Signed',
      professional: 'Professional',
      validationCode: 'Validation code',
      infoSection: 'Medical record information',
      notInformed: 'Not informed',
      noFields: 'There is no information filled in this medical record.',
      evolutions: 'Evolutions',
      evaluation: 'Evaluation',
      noObservation: 'No observations provided.',
      noEvolution: 'No evolution registered for this medical record.',
      timeAt: 'at',
    },
  },
  dashboard: {
    error: {
      title: 'Error',
      financials: 'Failed to list financial accounts',
      schedules: 'Failed to list appointments',
    },
    hero: {
      badge: 'Main panel',
      greeting: 'Hello, {{name}}',
      subtitle: "See the clinic's most important numbers for today.",
    },
    actions: {
      viewSchedule: 'View schedule',
      goFinancials: 'Go to financials',
      quickTitle: 'Quick actions',
      cashFlow: 'Cash flow',
      fullSchedule: 'Full schedule',
      createExpense: 'Create expense',
      details: 'View details',
      overdueAccounts: 'View accounts',
      receivables: 'View receivables',
      report: 'Report',
    },
    tooltips: {
      goSchedule: 'Go to schedule',
      whatsappSettings: 'WhatsApp settings',
    },
    cards: {
      schedulesToday: "TODAY'S APPOINTMENTS",
      schedulesDescription: 'Total scheduled patients',
      overduePayables: 'PAYABLES (OVERDUE)',
      pendingTitles: '{{count}} pending titles',
      receivablesToday: 'RECEIVABLES TODAY',
      expectedInvoices: '{{count}} expected invoices',
      whatsappMonth: 'WHATSAPP (MONTH)',
      whatsappDescription: 'Sends recorded through Meta API',
      attention: 'Attention',
    },
  },
  schedulesPage: {
    error: {
      title: 'Error',
      listSchedules: 'Failed to list appointments',
      listProfessionals: 'Failed to list professionals',
      listHolidays: 'Failed to list holidays',
      listClients: 'Failed to list clients',
      listStatus: 'Failed to list statuses',
    },
    info: {
      holidayTitle: 'Holiday',
      confirmedAt: 'Confirmed on: {{date}}',
    },
    intro: {
      badge: 'Schedule',
      title: 'Clinic schedule',
      description:
        'Organize appointments, view confirmations and track team occupancy in a single view.',
    },
    actions: {
      newSchedule: 'New appointment',
      reports: 'Reports',
      schedulesReport: 'Appointments report',
    },
    filters: {
      professional: 'Professional',
      professionalPlaceholder: 'Filter by professional',
      allProfessionals: 'All professionals',
    },
    calendar: {
      today: 'Today',
      month: 'Month',
      week: 'Week',
      day: 'Day',
      list: 'List',
    },
  },
  scheduleConfirm: {
    loading: 'Loading appointment...',
    error: {
      title: 'Error',
      foundSuccess: 'Appointment found successfully!',
      invalidLink: 'Invalid or expired link',
      missingParams: 'Invalid link: missing parameters',
      processConfirmation: 'Failed to process confirmation',
      invalidTitle: 'Invalid or Expired Link',
      notFoundTitle: 'Appointment not found',
      notFoundDescription: 'Sorry, we could not find this appointment.',
    },
    confirmation: {
      successTitle: 'Success',
      confirmedSuccess: 'Appointment confirmed successfully!',
      cancelledSuccess: 'Appointment declined successfully!',
      confirmedToast: 'Your appointment has been confirmed',
      cancelledToast: 'Your decline has been recorded',
      confirmedCardTitle: 'Appointment Confirmed!',
      cancelledCardTitle: 'Appointment Cancelled',
      confirmedAt: 'Confirmed on: {{date}}',
      backHome: 'Back to Home',
    },
    hero: {
      title: 'Appointment Confirmation',
      description: 'Review your appointment details and confirm to proceed',
    },
    details: {
      dateTime: 'Date and Time',
      fromTo: '{{date}} from {{start}} to {{end}}',
      daysUntilOne: '{{count}} day left',
      daysUntilOther: '{{count}} days left',
      clinic: 'Clinic',
      professional: 'Professional',
      patient: 'Patient',
      phone: 'Phone',
      address: 'Address',
      observation: 'Observation',
    },
    decision: {
      title: 'How would you like to proceed?',
      confirm: 'Confirm',
      cancel: 'Cancel',
      cancelReason: 'Cancellation reason',
      cancelReasonPlaceholder:
        'Help us improve by telling us why you are cancelling...',
      confirmAction: 'Confirm Appointment',
      cancelAction: 'Cancel Appointment',
    },
    modal: {
      confirmTitle: 'Confirm Appointment',
      cancelTitle: 'Cancel Appointment',
      confirmOk: 'Yes, confirm',
      cancelOk: 'Yes, cancel',
      back: 'No, go back',
      confirmQuestion:
        'Do you confirm that you want to schedule this appointment?',
      cancelQuestion: 'Are you sure you want to cancel this appointment?',
      confirmDescription: 'You will receive a confirmation by email',
      cancelDescription: 'The clinic will receive a cancellation notification',
    },
  },
  financialsPage: {
    toast: {
      errorTitle: 'Error',
      warningTitle: 'Warning',
      listPayments: 'Failed to list payment methods',
      selectAtLeastOne: 'Select at least one account',
      removeCancelled: 'Remove cancelled accounts from the selection',
      selectPendingOnly: 'Select only pending accounts to pay',
      listAccounts: 'Failed to list accounts',
    },
    status: {
      cancelled: 'Cancelled',
      received: 'Received',
      overdue: 'Overdue',
      pending: 'Pending',
      open: 'Open',
      paid: 'Paid',
      openPaid: 'Open/Paid',
    },
    actions: {
      edit: 'Edit',
      pay: 'Settle/Pay',
      reverse: 'Reverse',
      receipt: 'Receipt',
      newEntry: 'New entry',
      cashRegister: 'Cash register',
      quickSale: 'Quick sale',
      paySelected: 'Settle selected',
      cancelSelected: 'Cancel selected',
      reports: 'Reports',
      cashFlow: 'Cash flow',
      dre: 'Income statement',
      accountsPayable: 'Accounts payable',
      accountsReceivable: 'Accounts receivable',
      movements: 'Financial movements',
      delinquency: 'Delinquency',
      advancedReports: 'Advanced reports',
      commissionClosing: 'Commission closing',
      moreActions: 'More actions',
      back: 'Back',
      clear: 'Clear',
      filter: 'Filter',
    },
    intro: {
      badge: 'Financial',
      title: 'Financial management',
      description:
        'Track income, expenses and delinquency with quick filters and a consolidated view of the main values for the period.',
    },
    filters: {
      searchPlaceholder: 'Search...',
      advanced: 'Advanced filters',
      typePlaceholder: 'Type',
      typeIncome: 'Income',
      typeExpense: 'Expense',
      statusPlaceholder: 'Status',
      filterByPlaceholder: 'Filter by',
      dueDate: 'Due date',
      paymentDate: 'Payment',
      competenceDate: 'Competence',
    },
    summary: {
      confirmedReceived: 'Received (Confirmed)',
      pendingReceivable: 'Receivable (Pending)',
      paidExpenses: 'Paid (Expenses)',
      pendingPayable: 'Payable (Pending)',
    },
    table: {
      id: 'ID',
      type: 'Type',
      clientCode: 'Code',
      clientSupplier: 'Client/Supplier',
      dueDate: 'Due date',
      paymentDate: 'Payment',
      value: 'Amount',
      paymentMethod: 'Payment method',
      status: 'Status',
      income: 'INCOME',
      expense: 'EXPENSE',
    },
    createEdit: {
      titleCreate: 'New financial entry',
      titleEdit: 'Edit entry No. {{code}}',
      description:
        'Register income and expenses with a consistent visual structure focused on the main entry information.',
      sections: {
        entryInfo: 'Entry Information',
        financialDetails: 'Financial Details',
        observations: 'Notes',
      },
      movementTypes: {
        income: 'Income (Inflow)',
        expense: 'Expense (Outflow)',
      },
      fields: {
        movementType: 'Movement Type',
        description: 'Description',
        descriptionPlaceholder: 'Ex: Rent, Counter Sale...',
        client: 'Client',
        supplier: 'Supplier',
        selectPlaceholder: 'Select...',
        accountPlan: 'Chart of Accounts',
        accountPlanPlaceholder: 'Classification...',
        value: 'Amount',
        dueDate: 'Due Date',
        paymentMethod: 'Payment Method',
        documentNumber: 'Document No.',
        installments: 'Installments',
        options: 'Options',
        repeatValue: 'Repeat Amount',
        splitValue: 'Split Amount',
        observationsPlaceholder: 'Additional details about this entry...',
      },
      actions: {
        create: 'Create Entry',
        save: 'Save Changes',
      },
      toast: {
        loadDataError: 'Error loading data',
        loadDependenciesError: 'Error loading dependencies',
        successTitle: 'Success',
        errorTitle: 'Error',
        warningTitle: 'Warning',
        created: 'Entry created successfully',
        updated: 'Entry updated',
        checkFields: 'Check the fields',
      },
      validation: {
        typeRequired: 'Type is required',
        clientRequired: 'Client is required',
        descriptionRequired: 'Description is required',
        dueDateRequired: 'Due date is required',
        valueMin: 'Amount must be greater than zero',
        valueRequired: 'Amount is required',
        documentNumberRequired: 'Document number is required',
      },
    },
  },
  statusFinancial: {
    open: 'Open',
    paid: 'Paid',
    overdue: 'Overdue',
    cancelled: 'Cancelled',
  },
  statusItemTreatment: {
    inProgress: 'In progress',
    completed: 'Completed',
    pending: 'Pending',
  },
  treatmentsPage: {
    toast: {
      errorTitle: 'Error',
      listError: 'Failed to list treatments',
    },
    actions: {
      refresh: 'Refresh',
      create: 'Create',
      reports: 'Reports',
      production: 'Production',
      treatments: 'Treatments',
      procedures: 'Procedures',
      moreActions: 'More actions',
      back: 'Back',
      view: 'View',
      approveReject: 'Approve/Reject',
      edit: 'Edit',
      evolution: 'Evolution',
      print: 'Print',
    },
    intro: {
      badge: 'Treatments',
      title: 'Estimates and treatments',
      description:
        'Track approvals, appointment progress and treatment evolution in a single view.',
    },
    searchPlaceholder: 'Search...',
    stats: {
      total: 'Total',
      approved: 'Approved',
      pending: 'Pending',
      inProgress: 'In progress',
    },
    filters: {
      all: 'All',
      budgets: 'Estimates',
      treatments: 'Treatments',
    },
    table: {
      id: 'Id',
      type: 'Type',
      client: 'Client',
      professional: 'Professional',
      total: 'Total',
      progress: 'Progress',
      situation: 'Status',
      signature: 'Signature',
      options: 'Options',
      typeTreatment: 'TREAT',
      typeBudget: 'EST',
      approved: 'Approved',
      rejected: 'Rejected',
      pending: 'Pending',
      signed: 'Signed',
      unsigned: 'Unsigned',
    },
  },
  clientsPage: {
    toast: {
      errorTitle: 'Error',
      listError: 'Failed to list clients',
    },
    intro: {
      badge: 'Records',
      title: 'Clients and suppliers',
      description:
        'Track the clinic registry base, search quickly and access the main reports without leaving the list.',
    },
    actions: {
      refresh: 'Refresh',
      create: 'Create',
      clientsReport: 'Clients report',
      birthdays: 'Birthdays',
    },
    table: {
      id: 'Id',
      type: 'Type',
      document: 'CPF/CNPJ',
      name: 'Corporate name/Name',
      phone: 'Mobile phone',
      status: 'Status',
      options: 'Options',
      code: 'Code',
    },
  },
  proceduresPage: {
    toast: {
      errorTitle: 'Error',
      listError: 'Failed to list procedures',
    },
    intro: {
      badge: 'Records',
      title: 'Procedures',
      description:
        'Manage available procedures, review prices and quickly access item creation and editing.',
    },
    actions: {
      refresh: 'Refresh',
      create: 'Create',
      edit: 'Edit',
    },
    table: {
      id: 'Id',
      description: 'Description',
      price: 'Price',
      status: 'Status',
      options: 'Options',
    },
    modal: {
      validation: {
        descriptionRequired: 'Description is required',
        priceMin: 'Amount must be greater than zero',
        priceRequired: 'Price is required',
        statusRequired: 'Status is required',
      },
      toast: {
        successTitle: 'Created',
        infoTitle: 'Updated',
        errorTitle: 'Error',
        blankFieldsTitle: 'Blank fields',
        createdDescription: 'Created successfully.',
        updatedDescription: 'Data updated successfully.',
        createError: 'Error creating record',
        editError: 'Error editing.',
      },
      titleCreate: 'Create',
      titleEdit: 'Edit',
      fields: {
        description: 'Description',
        descriptionPlaceholder: 'Enter the description',
        price: 'Price',
        pricePlaceholder: 'Enter the price',
        active: 'Active',
        dental: 'Is dental?',
      },
    },
  },
  specialtiesModal: {
    validation: {
      descriptionRequired: 'Description is required',
      statusRequired: 'Status is required',
    },
    toast: {
      successTitle: 'Created',
      infoTitle: 'Updated',
      errorTitle: 'Error',
      blankFieldsTitle: 'Blank fields',
      createdDescription: 'Created successfully.',
      updatedDescription: 'Data updated successfully.',
      createError: 'Error creating record.',
      editError: 'Error updating.',
    },
    titleCreate: 'Create',
    titleEdit: 'Edit',
    fields: {
      description: 'Description',
      descriptionPlaceholder: 'Enter the description',
      active: 'Active',
    },
  },
  covenantsModal: {
    validation: {
      descriptionRequired: 'Description is required',
      statusRequired: 'Status is required',
    },
    toast: {
      successTitle: 'Created',
      infoTitle: 'Updated',
      errorTitle: 'Error',
      blankFieldsTitle: 'Blank fields',
      createdDescription: 'Created successfully.',
      updatedDescription: 'Data updated successfully.',
      createError: 'Error creating record.',
      editError: 'Error editing.',
    },
    titleCreate: 'Create',
    titleEdit: 'Edit',
    fields: {
      description: 'Description',
      descriptionPlaceholder: 'Enter the description',
      active: 'Active',
    },
  },
  addressModal: {
    validation: {
      cepRequired: 'ZIP code is required',
      streetRequired: 'Street is required',
      neighborhoodRequired: 'Neighborhood is required',
      cityRequired: 'City is required',
      stateRequired: 'State is required',
    },
    toast: {
      successTitle: 'Created',
      infoTitle: 'Updated',
      errorTitle: 'Error',
      blankFieldsTitle: 'Blank fields',
      cepNotFoundTitle: 'ZIP code not found',
      cepNotFoundDescription: 'Unable to find the informed ZIP code.',
      createdDescription: 'Created successfully.',
      updatedDescription: 'Data updated successfully.',
    },
    titleCreate: 'Create',
    titleEdit: 'Edit',
    fields: {
      cep: 'ZIP code',
      cepPlaceholder: 'ZIP code',
      street: 'Street',
      streetPlaceholder: 'Enter the street',
      number: 'Number',
      numberPlaceholder: 'Enter the number',
      neighborhood: 'Neighborhood',
      neighborhoodPlaceholder: 'Enter the neighborhood',
      complement: 'Complement',
      complementPlaceholder: 'Enter the complement',
      city: 'City',
      cityPlaceholder: 'Enter the city',
      state: 'State',
      statePlaceholder: 'Enter the state',
      active: 'Active',
    },
  },
  productCategoriesModal: {
    validation: {
      descriptionRequired: 'Description is required',
    },
    toast: {
      successTitle: 'Created',
      infoTitle: 'Updated',
      errorTitle: 'Error',
      blankFieldsTitle: 'Blank fields',
      createdDescription: 'Created successfully.',
      updatedDescription: 'Data updated successfully.',
      createError: 'Error creating record.',
      editError: 'Error editing.',
    },
    titleCreate: 'Create',
    titleEdit: 'Edit',
    fields: {
      description: 'Category description',
      descriptionPlaceholder: 'Enter an objective description',
      descriptionHelp:
        'This description will be used to organize products in stock.',
      status: 'Status',
      activeDescription: 'Active category for new products',
      inactiveDescription: 'Inactive category',
    },
  },
  schedulesStatusModal: {
    validation: {
      descriptionRequired: 'Description is required',
      colorRequired: 'Color is required',
      statusRequired: 'Status is required',
    },
    toast: {
      successTitle: 'Created',
      infoTitle: 'Updated',
      errorTitle: 'Error',
      blankFieldsTitle: 'Blank fields',
      createdDescription: 'Created successfully.',
      updatedDescription: 'Data updated successfully.',
      createError: 'Error creating record.',
      editError: 'Error editing.',
    },
    titleCreate: 'Create',
    titleEdit: 'Edit',
    fields: {
      description: 'Description',
      descriptionPlaceholder: 'Enter the description',
      color: 'Color',
      colorPlaceholder: 'Enter the color',
      active: 'Active',
    },
  },
  guidesStatusModal: {
    validation: {
      descriptionRequired: 'Description is required',
      colorRequired: 'Color is required',
      statusRequired: 'Status is required',
    },
    toast: {
      successTitle: 'Created',
      infoTitle: 'Updated',
      errorTitle: 'Error',
      blankFieldsTitle: 'Blank fields',
      createdDescription: 'Created successfully.',
      updatedDescription: 'Data updated successfully.',
      createError: 'Error creating record.',
      editError: 'Error editing.',
    },
    titleCreate: 'Create',
    titleEdit: 'Edit',
    fields: {
      description: 'Description',
      descriptionPlaceholder: 'Enter the description',
      color: 'Color',
      colorPlaceholder: 'Enter the color',
      active: 'Active',
    },
  },
  financialPlansModal: {
    validation: {
      descriptionRequired: 'Description is required',
      statusRequired: 'Status is required',
    },
    toast: {
      successTitle: 'Created',
      infoTitle: 'Updated',
      errorTitle: 'Error',
      blankFieldsTitle: 'Blank fields',
      createdDescription: 'Created successfully.',
      updatedDescription: 'Data updated successfully.',
      createError: 'Error creating record.',
      editError: 'Error editing.',
    },
    titleCreate: 'Create',
    titleEdit: 'Edit',
    fields: {
      description: 'Description',
      descriptionPlaceholder: 'Enter the description',
      active: 'Active',
    },
  },
  holidaysModal: {
    validation: {
      descriptionRequired: 'Description is required',
      dayRequired: 'Day is required',
      monthRequired: 'Month is required',
      statusRequired: 'Status is required',
    },
    toast: {
      successTitle: 'Created',
      infoTitle: 'Updated',
      errorTitle: 'Error',
      blankFieldsTitle: 'Blank fields',
      createdDescription: 'Created successfully.',
      updatedDescription: 'Data updated successfully.',
      createError: 'Error creating record.',
      editError: 'Error editing.',
    },
    titleCreate: 'Create',
    titleEdit: 'Edit',
    fields: {
      description: 'Description',
      descriptionPlaceholder: 'Enter the description',
      day: 'Day',
      dayPlaceholder: 'Select the day',
      month: 'Month',
      monthPlaceholder: 'Select the month',
      active: 'Active',
    },
    months: {
      january: 'January',
      february: 'February',
      march: 'March',
      april: 'April',
      may: 'May',
      june: 'June',
      july: 'July',
      august: 'August',
      september: 'September',
      october: 'October',
      november: 'November',
      december: 'December',
    },
  },
  toSignature: {
    title: 'Authenticate digital signature',
    fields: {
      password: 'Signature password',
      passwordPlaceholder: 'Enter the professional signature password',
    },
    toast: {
      warningTitle: 'Warning',
      errorTitle: 'Error',
      passwordRequired: 'Enter the signature password',
    },
  },
  productModal: {
    validation: {
      nameRequired: 'Description is required',
      productTypeRequired: 'Product type is required',
      salePriceMin: 'Sale price must be greater than zero',
      salePriceRequired: 'Sale price is required for sellable products',
      salePriceInvalid: 'Invalid price',
      minimumInventoryMin: 'Minimum stock must be greater than zero',
      minimumInventoryRequired: 'Minimum stock is required',
      maximumInventoryMin: 'Maximum stock must be greater than zero',
      maximumInventoryRequired: 'Maximum stock is required',
    },
    toast: {
      successTitle: 'Created',
      infoTitle: 'Updated',
      errorTitle: 'Error',
      blankFieldsTitle: 'Blank fields',
      createdDescription: 'Created successfully.',
      updatedDescription: 'Data updated successfully.',
      createError: 'Error creating record.',
      editError: 'Error editing.',
    },
    titleCreate: 'Create',
    titleEdit: 'Edit',
    productTypes: {
      supply: 'Supply',
      retail: 'Product for sale',
    },
    sections: {
      inventory: 'Inventory control',
    },
    fields: {
      name: 'Name',
      namePlaceholder: 'Enter the product name',
      description: 'Description',
      descriptionPlaceholder:
        'Add a short description to make identification easier',
      category: 'Product category',
      categoryPlaceholder: 'Select the category',
      productType: 'Product type',
      unity: 'Unit',
      unityPlaceholder: 'Select',
      salePrice: 'Base sale price',
      salePricePlaceholder: 'Ex: 49.90',
      salePriceDisabledPlaceholder: 'Not applicable for supplies',
      minimumInventory: 'Minimum stock',
      minimumInventoryPlaceholder: 'Ex: 10',
      maximumInventory: 'Maximum stock',
      maximumInventoryPlaceholder: 'Ex: 100',
      inventoryHelp: 'Enter the limits for replenishment alerts',
      inventoryRange: 'Configured range: {{min}} to {{max}}{{unity}}',
      productStatus: 'Product status',
      activeDescription: 'Active product for movements',
      inactiveDescription: 'Inactive product',
    },
  },
  inventoryEntriesPage: {
    toast: {
      errorTitle: 'Error',
      listEntries: 'Failed to list entries',
      listProducts: 'Failed to list products',
    },
    intro: {
      badge: 'Inventory',
      title: 'Inventory restocking',
      description:
        'Use this screen when a product entered the clinic: purchase, restocking, return or manual quantity adjustment.',
    },
    actions: {
      refresh: 'Refresh',
      newEntry: 'New entry',
      view: 'View',
    },
    stats: {
      registeredEntries: 'Registered restocking',
      purchasedValue: 'Purchased value',
      receivedQuantity: 'Received quantity',
      usedSuppliers: 'Suppliers used',
    },
    table: {
      date: 'Date',
      product: 'Product',
      source: 'Source',
      receivedQuantity: 'Qty received',
      unitPrice: 'Unit price',
      options: 'Options',
    },
  },
  modelsFormsCreateEdit: {
    validation: {
      titleRequired: 'Title is required',
      missingInputs: 'Form fields are missing',
      inputTypeRequired: 'Type is required',
      inputLabelRequired: 'Field is required',
    },
    toast: {
      infoTitle: 'Info',
      successTitle: 'Success',
      errorTitle: 'Error',
      blankFields: 'Blank fields',
      updated: 'Medical record updated successfully',
      created: 'Medical record created successfully',
      createError: 'Error creating record',
      editError: 'Error editing record',
    },
    intro: {
      badge: 'Templates',
      createTitle: 'Create medical record template',
      editTitle: 'Edit medical record template',
      description:
        'Configure medical record templates and their fields with the shared visual shell.',
    },
    fields: {
      title: 'Title',
      titlePlaceholder: 'Medical record title',
      description: 'Description',
      descriptionPlaceholder: 'Medical record description',
      active: 'Active',
      inputs: 'Fields',
      addInput: 'Add field',
    },
    inputModal: {
      validation: {
        noOptionsTitle: 'No options',
        noOptionsDescription: 'At least one option is required',
        emptyOptionsTitle: 'Option(s) without values',
        emptyOptionsDescription: 'Option field(s) without values',
      },
      toast: {
        successTitle: 'Success',
        infoTitle: 'Updated',
        errorTitle: 'Error',
        blankFields: 'Blank fields',
        created: 'Created successfully.',
        updated: 'Updated successfully.',
        createError: 'Error creating record',
        editError: 'Error editing record.',
      },
      titleCreate: 'Create',
      titleEdit: 'Edit',
      fields: {
        type: 'Field type',
        typePlaceholder: 'Enter the field type',
        question: 'Question text',
        questionPlaceholder: 'Enter the text',
        order: 'Question order',
        orderPlaceholder: 'Enter the field order Ex: 1, 2, 3...',
        required: 'Required?',
        active: 'Active',
        options: 'Options',
        addOption: 'Add option',
        optionValuePlaceholder: 'Value',
      },
    },
  },
  modelsDocumentsCreateEdit: {
    validation: {
      titleRequired: 'Name is required',
    },
    toast: {
      infoTitle: 'Updated',
      errorTitle: 'Error',
      blankFields: 'Blank fields',
      createdTitle: 'Created',
      created: 'Created successfully.',
      copiedTitle: 'Copied',
      copiedDescription: 'Keyword "{{keyword}}" copied to clipboard',
      updated: 'Data updated successfully.',
      createError: 'Error creating record',
      editError: 'Error editing record',
    },
    intro: {
      badge: 'Templates',
      createDocument: 'Create document template',
      editDocument: 'Edit document template',
      createPrescription: 'Create prescription template',
      editPrescription: 'Edit prescription template',
      prescriptionDescription:
        'Configure an electronic prescription template with placeholders for prescribed items, date and guidelines.',
      documentDescription:
        'Configure reusable document templates within the system visual standard.',
    },
    status: {
      active: 'ACTIVE',
      inactive: 'INACTIVE',
    },
    sections: {
      basicInfo: 'Basic Information',
      keywords: 'Available Keywords',
      content: 'Document Content',
      modelStatus: 'Template Status',
    },
    fields: {
      prescriptionTitle: 'Prescription Title',
      documentTitle: 'Document Title',
      modelType: 'Template Type',
      text: 'Text',
      activateModel: 'Activate template',
    },
    placeholders: {
      titleExample: 'Ex.: EVALUATION REPORT',
    },
    tooltips: {
      modelName: 'Name that identifies this template',
      modelNameDescription:
        'Enter a descriptive name for this template (ex: EVALUATION REPORT)',
      deactivateModel: 'Disable to hide this template from users',
      copyKeyword: 'Copy keyword',
    },
    options: {
      document: 'Document',
      prescription: 'Electronic prescription',
    },
    instructions: {
      keywords:
        'Copy and paste the keywords into the template text. They will be automatically replaced with client data when the document is generated.',
      importantTitle: 'Important:',
      importantDescription: 'Keywords must be typed exactly as shown above',
      content:
        'Write the document text. Use the keywords above to insert dynamic data that will be filled automatically.',
    },
    keywords: {
      name: 'Client name',
      cpf: 'Client CPF',
      birthDate: 'Client birth date',
      phone: 'Client mobile number',
      gender: 'Client gender',
      maritalStatus: 'Client marital status',
      email: 'Client e-mail',
      nationality: 'Client nationality',
      naturalness: 'Client place of birth',
      profession: 'Client profession',
      zipCode: 'Client address ZIP code',
      street: 'Client address street',
      number: 'Client address number',
      district: 'Client address district',
      complement: 'Client address complement',
      city: 'Client address city',
      state: 'Client address state',
      prescriptionDate: 'Prescription issue date',
      prescriptionItems: 'List of prescribed medicines',
      prescriptionGuidelines: 'Additional prescription guidelines',
    },
    template: {
      patient: 'Patient',
      date: 'Date',
    },
  },
  sendScheduleConfirmation: {
    defaultClientName: 'Client',
    messages: {
      copied: 'Link copied to clipboard!',
      emailRequired: 'Enter an email address',
      emailSent: 'Email sent successfully!',
      emailError: 'Error sending email',
      phoneRequired: 'Enter a phone number',
      whatsappSent: 'WhatsApp message sent successfully!',
      whatsappError: 'Error sending WhatsApp message',
    },
    title: 'Send Appointment Confirmation Link',
    close: 'Close',
    to: 'To',
    sections: {
      link: 'Confirmation Link',
      email: 'Send by Email',
      whatsapp: 'Send by WhatsApp',
      info: 'Important information:',
    },
    actions: {
      copyLink: 'Copy Link',
      sendEmail: 'Send Email',
      sending: 'Sending...',
      sendWhatsapp: 'Send WhatsApp',
    },
    fields: {
      emailPlaceholder: 'Client email',
      phonePlaceholder: 'Client phone (with country code)',
    },
    hints: {
      expiry: 'This link expires in 7 days',
      phoneFormat: 'Format: +55 (99) 99999-9999',
    },
    infoList: {
      valid: 'The link is valid for 7 days',
      confirmOrCancel: 'The client can confirm or cancel through the link',
      confirmationNotice: 'After confirmation, you will receive a notification',
      singleUse: 'The link cannot be reused',
    },
  },
  modelsFormsPage: {
    toast: {
      errorTitle: 'Error',
      listError: 'Failed to list medical records',
    },
    intro: {
      badge: 'Templates',
      title: 'Medical record templates',
      description:
        'Keep clinical templates organized in a view aligned with the new internal screen standard.',
    },
    actions: {
      refresh: 'Refresh',
      create: 'Create',
      edit: 'Edit',
    },
    table: {
      title: 'Title',
      status: 'Status',
      options: 'Options',
    },
  },
  modelsDocumentsPage: {
    toast: {
      errorTitle: 'Error',
      listError: 'Failed to list templates',
    },
    intro: {
      badge: 'Templates',
      titleDocuments: 'Document templates',
      titlePrescriptions: 'Prescription templates',
      descriptionDocuments:
        'Centralize the templates used by the clinic in a clearer list consistent with the rest of the interface.',
      descriptionPrescriptions:
        'Organize electronic prescription templates with the same signing and printing flow already used by the system.',
    },
    actions: {
      refresh: 'Refresh',
      create: 'Create',
      createPrescription: 'Create prescription',
      edit: 'Edit',
    },
    filters: {
      documents: 'Documents',
      prescriptions: 'Prescriptions',
    },
    table: {
      index: '#',
      title: 'Title',
      status: 'Status',
      options: 'Options',
    },
  },
  insertPayment: {
    toast: {
      errorTitle: 'Error',
      fillAllFields: 'Fill in all fields',
    },
    installments: {
      single: '{{count}} time',
      multiple: '{{count}} times',
    },
    modal: {
      title: 'Insert Payment',
      ok: 'Insert',
    },
    fields: {
      paymentMethod: 'Payment Method',
      paymentMethodPlaceholder: 'Select the payment method',
      value: 'Amount',
      installments: 'Installments',
      installmentsPlaceholder: 'Select the number of installments',
      dueDate: 'Due Date',
    },
  },
  treatmentProductsModal: {
    messages: {
      loadProductsError: 'Error loading products',
      loadTreatmentProductsError: 'Error loading treatment products',
      addSuccess: 'Product added successfully',
      addError: 'Error adding product',
      updateError: 'Error updating product',
      removeSuccess: 'Product removed successfully',
      removeError: 'Error removing product',
    },
    modal: {
      title: 'Treatment Products {{suffix}}',
      dentalSuffix: 'Dental',
      close: 'Close',
    },
    table: {
      product: 'Product',
      quantity: 'Quantity',
      unitPrice: 'Unit Price',
      total: 'Total',
      actions: 'Actions',
      notFound: 'Product not found',
    },
    addSection: {
      title: 'Add New Product',
      helper: 'Select a product to add',
      placeholder: 'Search by code or name',
      button: 'Add',
      allAdded: 'All available products have already been added',
    },
    addedSection: {
      title: 'Added Products',
      empty: 'No product added',
      emptyHelper: 'Select a product above to get started',
      helper: 'Edit quantity and price as needed',
    },
    summary: {
      totalProducts: 'Total Products:',
      totalValue: 'Total Amount:',
    },
    retail: {
      loadProductsError: 'Error loading products for direct sale',
      selectProductWarning: 'Select a product to continue',
      quantityWarning: 'Enter a quantity greater than zero',
      unitPriceWarning: 'Unit price cannot be negative',
      modalTitle: 'Direct Sale Products',
      modalOk: 'Finish',
      buildSaleTitle: 'Build direct sale',
      product: 'Product',
      productPlaceholder: 'Search by code or name',
      quantity: 'Quantity',
      unitPrice: 'Unit price',
      addButton: 'Add',
      helper:
        'Use this area for products sold during the appointment that do not need to be clinically linked to the treatment protocol. Only items marked as products for sale appear here.',
      itemsTitle: 'Direct sale items',
      empty: 'No direct sale product added',
      productNotFound: 'Product not found',
      actions: 'Actions',
      detachedItems: 'Detached items',
      projectedTotal: 'Projected total',
    },
  },
  usersPage: {
    validation: {
      nameRequired: 'Name is required',
      cpfRequired: 'CPF is required',
      invalidCpf: 'invalid cpf',
      phoneRequired: 'Phone is required',
      birthDateRequired: 'Birth date is required',
      loginRequired: 'Login is required',
      accessGroupRequired: 'Access group is required',
      passwordRequired: 'Password is required',
      passwordConfirmationRequired: 'Password confirmation is required',
      passwordMismatch: 'Password does not match confirmation password.',
    },
    toast: {
      errorTitle: 'Error',
      blankFields: 'Blank fields',
      listError: 'Error listing chart of accounts',
      listAccessGroupsError: 'Error listing access groups',
      updatedTitle: 'User updated',
      updatedDescription: 'User data updated successfully.',
      createdTitle: 'User created',
      createdDescription: 'User created successfully.',
      editError: 'Error updating.',
      createError: 'Error creating record',
    },
    intro: {
      badge: 'Records',
      listTitle: 'Users',
      listDescription:
        'Manage internal accounts, access and password resets using the same layout as the other administrative screens.',
      createTitle: 'Create user',
      editTitle: 'Edit user',
      formDescription:
        'Define personal data, access group and credentials in a screen standardized with the rest of the system.',
    },
    actions: {
      refresh: 'Refresh',
      create: 'Create',
      edit: 'Edit',
      resetPassword: 'Reset Password',
    },
    table: {
      cpf: 'CPF',
      name: 'Name',
      birthDate: 'Birth date',
      login: 'Login',
      status: 'Status',
      options: 'Options',
    },
    fields: {
      name: 'Name',
      namePlaceholder: 'Enter the name',
      cpf: 'CPF',
      cpfPlaceholder: 'Enter the CPF',
      birthDate: 'Birth date',
      accessGroup: 'Access Group',
      phone: 'Phone',
      phonePlaceholder: 'Enter the phone number',
      loginEmail: 'E-mail (Login)',
      password: 'Password',
      passwordPlaceholder: 'Enter the password',
      passwordConfirmation: 'Password confirmation',
      passwordConfirmationPlaceholder: 'Confirm your password',
      active: 'Active',
    },
    resetPassword: {
      modalTitle: 'Reset password?',
      confirmButton: 'Reset',
      description: 'Do you want to reset the password to the default [1 to 6]?',
      successTitle: 'Success',
      successDescription: 'Password reset successfully',
      errorDescription: 'Error resetting password.',
    },
  },
  companiesPage: {
    toast: {
      errorTitle: 'Error',
      successTitle: 'Success',
      fetchCompaniesError: 'Error fetching companies.',
      fetchPlansError: 'Error fetching global plans.',
      saveConfigSuccess: 'Status updated successfully!',
      createTenantSuccess: 'Company created successfully!',
      serverConnectionError: 'Error connecting to the server',
      savePlanSuccess: 'Plan saved successfully!',
      savePlanError: 'Error saving plan.',
    },
    shared: {
      none: 'None',
      notAvailable: '-',
      currencyPrefix: '$',
    },
    permission: {
      checking: 'Checking permissions...',
      deniedTitle: 'Access denied',
      deniedDescription: 'This is a restricted area for system management.',
      deniedHelper:
        'Only the manager tenant administrator profile has access permission.',
    },
    breadcrumb: {
      home: 'Home',
      current: 'Companies',
    },
    header: {
      title: 'Company Management (Tenants)',
    },
    summary: {
      total: 'Total tenants',
      active: 'Active tenants',
      blocked: 'Blocked tenants',
    },
    helperText: 'Create new tenants and manage modules and blocks per company.',
    actions: {
      back: 'Back',
      refresh: 'Refresh',
      newTenant: 'New Tenant',
      newPlan: 'New Plan',
      edit: 'Edit',
      configure: 'Settings',
    },
    status: {
      tenant: {
        active: 'Active',
        blocked: 'Blocked',
      },
      enabled: {
        active: 'Active',
        inactive: 'Inactive',
      },
      plan: {
        active: 'Active',
        trial: 'Trial',
        suspended: 'Suspended',
        canceled: 'Canceled',
      },
    },
    landing: {
      visible: 'Visible',
      hidden: 'Hidden',
    },
    legacyModules: {
      dental: 'Dental',
      medical: 'Medical',
      aesthetics: 'Aesthetics',
    },
    modules: {
      agenda: 'Schedule Control',
      clientes: 'Client Registration',
      financeiro: 'Financial',
      documentos: 'Documents',
      assinatura_digital: 'Digital Signature',
      tratamentos: 'Clinical Treatments',
      odontologico: 'Dentistry',
      atestados_medicos: 'Medical Certificates',
      formularios: 'Forms',
      guias: 'Guides',
      convenios: 'Insurance and Terminologies',
      estetica: 'Aesthetics',
      estoque: 'Inventory',
      produtos: 'Products',
      usuarios: 'Users',
      permissoes: 'Permissions and Access Groups',
      profissionais: 'Professionals',
      especialidades: 'Specialties',
      procedimentos: 'Procedures',
      whatsapp: 'WhatsApp',
      email: 'Email',
      empresa: 'Company Data',
    },
    autoConfirmationChannels: {
      both: 'WhatsApp and Email',
      whatsapp: 'WhatsApp only',
      email: 'Email only',
      disabled: 'Disabled',
    },
    table: {
      plans: {
        title: 'Global Plans',
        empty: 'No global plans registered.',
        limitSummary:
          '{{users}} users / {{professionals}} professionals / {{clients}} clients',
        columns: {
          code: 'Code',
          name: 'Name',
          monthlyFee: 'Monthly fee',
          limits: 'Limits',
          status: 'Status',
          landing: 'Landing',
          actions: 'Actions',
        },
      },
      tenants: {
        title: 'Registered Companies',
        empty: 'No company registered.',
        columns: {
          name: 'Name',
          status: 'Status',
          activeModules: 'Active Modules',
          plan: 'Plan',
          dueDate: 'Due date (days)',
          createdAt: 'Created At',
          actions: 'Actions',
        },
      },
    },
    createTenantModal: {
      title: 'Create Tenant',
      helper: "This name will be used to create the company's isolated schema.",
      fields: {
        identifier: 'Tenant identifier',
        identifierPlaceholder: 'Ex: central_clinic',
      },
      validation: {
        required: 'Enter the tenant name.',
        alreadyExists: 'A clinic with this identifier already exists.',
        createError: 'Error creating tenant.',
      },
    },
    planModal: {
      titleCreate: 'New Plan',
      titleEdit: 'Edit Plan {{name}}',
      saveButton: 'Save Plan',
      sections: {
        landing: 'Landing Information',
        allowedModules: 'Modules enabled by this plan',
      },
      fields: {
        code: 'Code:',
        name: 'Name:',
        description: 'Description:',
        landingSubtitle: 'Plan subtitle:',
        landingPrice: 'Price shown on landing:',
        landingPricePlaceholder: 'Ex: Upon request',
        landingFrequency: 'Displayed frequency:',
        landingFrequencyPlaceholder: 'Ex: /month',
        landingHighlight: 'Card highlight:',
        landingHighlightPlaceholder: 'Ex: Most chosen',
        landingSortOrder: 'Landing order:',
        landingFeatures: 'Landing benefits list:',
        landingFeaturesPlaceholder: 'One item per line',
        monthlyPriceCents: 'Monthly fee in cents:',
        maxUsers: 'Maximum Users:',
        maxProfessionals: 'Maximum Professionals:',
        maxClients: 'Maximum Clients:',
        defaultDueDate: 'Default due date:',
      },
      checkboxes: {
        landingVisible: 'Show this plan on the landing page',
        recommendedDental: 'Dental by default',
        recommendedMedical: 'Medical by default',
        recommendedAesthetics: 'Aesthetics by default',
        recommendedShowClientCode: 'Show client code by default',
        status: 'Active plan',
      },
      allowedModulesHelper:
        'Select the modules the customer will have access to when subscribing to this plan.',
    },
    configModal: {
      title: 'Settings for {{name}}',
      loadError: 'Error loading settings.',
      sections: {
        planManager: 'Plan Manager',
        overrides: 'Tenant Overrides',
        moduleOverrides: 'Module Override',
      },
      fields: {
        autoConfirmationChannel: 'Automatic appointment confirmation channel:',
        planSuggestions: 'Plan Suggestions:',
        planSuggestionsPlaceholder: 'Select a suggested plan',
        planStatus: 'Plan Status:',
        planStartedAt: 'Plan Start (YYYY-MM-DD):',
        planEndsAt: 'Plan End (YYYY-MM-DD):',
        maxUsers: 'User Limit:',
        maxProfessionals: 'Professional Limit:',
        maxClients: 'Client Limit:',
        dueDate: 'Days Until Due Date:',
      },
      checkboxes: {
        blockClient: 'Block Client',
        dentalModule: 'Dental Module',
        medicalModule: 'Medical Module',
        aestheticsModule: 'Aesthetics Module',
        showClientCode: 'Show Client Code',
        customizeModules: 'Customize modules for this client',
      },
      planCard: {
        noPlanSelected: 'No plan selected',
        code: 'Code: {{code}}',
        monthlyFee: 'Monthly fee: {{amount}}',
        basePlan:
          'Base plan: {{users}} users, {{professionals}} professionals, {{clients}} clients',
        descriptionEmpty: 'Select a plan to view details.',
      },
      overridesHelper:
        'If you change any value below, it will apply only to this client without changing the global plan.',
      moduleOverridesHelper:
        'Leave blank to inherit the plan modules. Check here only if you want to enable or restrict specific modules for this client only.',
    },
  },
  dentalPage: {
    intro: {
      badge: 'Dentistry',
      title: 'Dental budgets and treatments',
      description:
        'Centralize approvals, clinical progress, and signatures for dental treatments in one view.',
    },
    actions: {
      refresh: 'Refresh',
      create: 'Create',
      moreActions: 'More actions',
      back: 'Back',
      view: 'View',
      approveOrReject: 'Approve/Reject',
      edit: 'Edit',
      evolution: 'Progress',
      print: 'Print',
    },
    toast: {
      errorTitle: 'Error',
      listError: 'Error listing treatments',
    },
    stats: {
      total: 'Total',
      approved: 'Approved',
      pending: 'Pending',
      inProgress: 'In progress',
    },
    filters: {
      all: 'All',
      budgets: 'Budgets',
      treatments: 'Treatments',
    },
    searchPlaceholder: 'Search...',
    table: {
      id: 'Id',
      type: 'Type',
      typeTreatmentShort: 'TRMT',
      typeBudgetShort: 'BUDG',
      client: 'Client',
      professional: 'Professional',
      total: 'Total',
      progress: 'Progress',
      status: 'Status',
      signature: 'Signature',
      actions: 'Options',
    },
    status: {
      approved: 'Approved',
      rejected: 'Rejected',
      pending: 'Pending',
    },
    signature: {
      signed: 'Signed',
      notSigned: 'Unsigned',
    },
  },
  dentalCreateEdit: {
    intro: {
      createTreatmentTitle: 'Create treatment',
      createBudgetTitle: 'Create budget',
      editTreatmentTitle: 'Edit treatment',
      editBudgetTitle: 'Edit budget',
      codeSuffix: 'No. {{code}}',
    },
    types: {
      treatment: 'Treatment',
      budget: 'Budget',
    },
    sections: {
      basicInfo: 'Basic information',
      odontogram: 'Dental odontogram',
      procedures: 'Dental procedures',
    },
    fields: {
      procedureType: 'Procedure type',
      patient: 'Patient',
      professional: 'Professional',
    },
    tooltips: {
      procedureType: 'Select whether this is a full treatment or a budget',
      patient: 'Select the responsible patient',
      professional: 'Select the responsible professional',
    },
    placeholders: {
      patient: 'Select the patient',
      professional: 'Select the professional',
    },
    actions: {
      edit: 'Edit',
      remove: 'Remove',
      back: 'Back',
    },
    emptyState: {
      title: 'No dental procedure added yet',
      description: 'Click the teeth in the odontogram above to get started',
    },
    table: {
      tooth: 'Tooth',
      face: 'Face',
      currentState: 'Current state',
      procedure: 'Procedure',
      unitValue: 'Unit value',
      discount: 'Discount',
      total: 'Total',
      actions: 'Actions',
    },
    summary: {
      subtotal: 'Procedures subtotal:',
      discount: 'Total discount:',
      totalToPay: 'Total due:',
    },
    savedNotice: {
      title: 'Saved record:',
      description:
        'This dental {{type}} was saved successfully (No. {{code}}). You can view it in detail or print it using the print option.',
    },
    toast: {
      successTitle: 'Success',
      savedTitle: 'Treatment saved',
      errorTitle: 'Error',
      blankFieldsTitle: 'Blank fields',
      createdDescription: '{{type}} created successfully',
      approvalRedirectWarning:
        'The treatment was saved, but the approval screen could not be opened automatically.',
      createError: 'Error creating record.',
      loadError: 'Error loading record.',
      listClientsError: 'Error listing clients.',
      listProfessionalsError: 'Error listing professionals',
    },
    odontogram: {
      invalidCondition: 'Invalid ID',
      conditions: {
        amalgam: 'Amalgam',
        caries: 'Caries',
        endodontics: 'Endodontics',
        missing: 'Missing',
        resin: 'Resin',
        implant: 'Implant',
        sealant: 'Sealant',
        crown: 'Crown',
        other: 'Other',
        clear: 'Clear',
      },
    },
    procedureModal: {
      toast: {
        successTitle: 'Success',
        infoTitle: 'Updated',
        errorTitle: 'Error',
        insertedDescription: 'Procedure inserted',
        updatedDescription: 'Procedure updated',
        insertError: 'Error inserting procedure',
        editError: 'Error editing procedure',
      },
      titleCreate: 'Insert procedure',
      titleEdit: 'Edit procedure',
      fields: {
        procedure: 'Procedure',
        procedurePlaceholder: 'Select the procedure',
        price: 'Price',
        toothNumber: 'Tooth number',
        toothFace: 'Tooth face',
        currentState: 'Current state',
      },
    },
  },
  odontogramRender: {
    title: 'Odontogram',
    instructions: 'Click the tooth faces to apply dental conditions',
    arches: {
      upperAdult: 'Upper arch - Adult',
      upperChild: 'Upper arch - Child',
      lowerChild: 'Lower arch - Child',
      lowerAdult: 'Lower arch - Adult',
    },
    toast: {
      selectConditionTitle: 'Notice',
      selectConditionDescription: 'Select a condition for the tooth.',
    },
    conditions: {
      amalgam: 'Amalgam',
      caries: 'Caries',
      endodontics: 'Endodontics',
      missing: 'Missing',
      resin: 'Resin',
      implant: 'Implant',
      sealant: 'Sealant',
      crown: 'Crown',
      other: 'Other',
    },
  },
  modelsHealthCertificatesPage: {
    intro: {
      badge: 'Templates',
      title: 'Certificate templates',
      description:
        'Manage certificate templates with the same visual standard used across the other configuration and registration screens.',
    },
    actions: {
      refresh: 'Refresh',
      create: 'Create',
      edit: 'Edit',
    },
    table: {
      index: '#',
      title: 'Title',
      status: 'Status',
      options: 'Options',
    },
    toast: {
      errorTitle: 'Error',
      listError: 'Error listing templates',
    },
  },
  modelsHealthCertificatesCreateEdit: {
    intro: {
      badge: 'Templates',
      createTitle: 'Create certificate template',
      editTitle: 'Edit certificate template',
      description:
        "Build reusable certificate templates following the system's internal visual standard.",
    },
    sections: {
      basicInfo: 'Basic information',
      keywords: 'Available keywords',
      content: 'Certificate content',
      status: 'Template status',
    },
    instructions: {
      basicInfo:
        'Define a clear title to identify this certificate template in the list and registration flow.',
      keywords:
        'Copy and paste the keywords into the certificate text. They will be automatically replaced with patient data when the certificate is generated.',
      content:
        'Write the certificate text. Use the keywords above to insert dynamic data that will be filled automatically.',
      status:
        'Disable the template to hide it from users without losing the configured content.',
    },
    fields: {
      title: 'Certificate title',
      text: 'Text',
      status: 'Enable template',
    },
    placeholders: {
      title: 'Ex.: ATTENDANCE CERTIFICATE',
      titleHelp:
        'Enter a descriptive name for this template (e.g. ATTENDANCE CERTIFICATE)',
    },
    tooltips: {
      title: 'Name that identifies this certificate template',
      status: 'Disable to hide this template from users',
    },
    status: {
      active: 'ACTIVE',
      inactive: 'INACTIVE',
    },
    toast: {
      errorTitle: 'Error',
      blankFieldsTitle: 'Blank fields',
      createdTitle: 'Created',
      createdDescription: 'Created successfully.',
      updatedTitle: 'Updated',
      updatedDescription: 'Data updated successfully.',
      createError: 'Error creating certificate template',
      editError: 'Error editing certificate template',
    },
    validation: {
      titleRequired: 'Name is required',
    },
  },
  patientHealthCertificatePrint: {
    error: {
      load: 'Could not load the certificate for printing.',
      notFound: 'Certificate not found.',
    },
    actions: {
      backToPanel: 'Back to panel',
    },
  },
  healthCertificateCreateEdit: {
    intro: {
      badge: 'Documents',
      createTitle: 'Create certificate',
      editTitle: 'Edit certificate',
      description:
        "Build the certificate with template, patient, professional, and signature inside the app's new visual standard.",
    },
    sections: {
      selection: 'Select template and people',
      appointmentInfo: 'Appointment information',
      keywords: 'Available keywords',
      content: 'Certificate content',
    },
    instructions: {
      selection:
        'Select the certificate template, patient, and responsible professional. The template will automatically load the certificate text.',
      appointmentInfo:
        'Fill in the time, date, and appointment duration. The CID code is optional.',
      keywords:
        'Copy and paste the keywords into the certificate text. They will be automatically replaced with the filled data when the certificate is generated.',
      content:
        'Write the certificate content. Use the keywords above to insert dynamic data that will be filled automatically with appointment information.',
    },
    fields: {
      model: 'Certificate template',
      patient: 'Patient',
      professional: 'Professional',
      startTime: 'Start time',
      endTime: 'End time',
      date: 'Appointment date',
      quantityDays: 'Number of days',
      cid: 'CID code (Optional)',
      text: 'Certificate text',
    },
    placeholders: {
      model: 'Certificate template',
      patient: 'Patient',
      professional: 'Professional',
      cid: 'Ex.: J06 - Upper respiratory tract infection',
    },
    tooltips: {
      model: 'Select the certificate template',
      patient: 'Select the patient responsible for the certificate',
      professional: 'Select the responsible professional',
      startTime: 'Appointment start time',
      endTime: 'Appointment end time',
      date: 'Date when the appointment took place',
      quantityDays: 'Number of days for the treatment/certificate',
      cid: 'International Classification of Diseases (e.g. J06)',
    },
    keywords: {
      patientName: 'Patient name',
      patientCpf: 'Patient CPF',
      daysCount: 'Number of treatment days',
      appointmentDate: 'Appointment date',
      startTime: 'Appointment start time',
      endTime: 'Appointment end time',
      cid: 'CID code (International Classification of Diseases)',
    },
    warning: {
      title: 'Important:',
      descriptionStart:
        'Keywords must be typed exactly as shown above (with braces',
      descriptionEnd: 'and without spaces).',
    },
    actions: {
      copyKeyword: 'Copy keyword',
      back: 'Back',
    },
    toast: {
      errorTitle: 'Error',
      blankFieldsTitle: 'Blank fields',
      createdTitle: 'Created',
      createdDescription: 'Created successfully.',
      updatedTitle: 'Updated',
      updatedDescription: 'Data updated successfully.',
      createError: 'Error creating record',
      editError: 'Error editing record',
      listProfessionalsError: 'Error listing professionals',
      listModelsError: 'Error listing certificate templates',
      keywordCopiedTitle: 'Copied',
      keywordCopiedDescription: 'Keyword "{{keyword}}" copied to the clipboard',
    },
    validation: {
      startTimeRequired: 'Start time is required',
      endTimeRequired: 'End time is required',
      futureDate: 'Date cannot be in the future',
      dateRequired: 'Appointment date is required',
      clientRequired: 'Client is required',
      professionalRequired: 'Professional is required',
      modelRequired: 'Certificate template is required',
      textRequired: 'Text field is required',
    },
  },
  scheduleConfirmationMessageModal: {
    title: 'Send appointment confirmation',
    description: 'Send confirmation to {{clientName}}. Appointment: {{date}}',
    actions: {
      sendWhatsapp: 'Send via WhatsApp',
      sendSms: 'Send via SMS',
    },
    channels: {
      whatsapp: 'WhatsApp',
      sms: 'SMS',
    },
    toast: {
      successTitle: 'Success',
      successDescription: 'Message via {{channel}} sent successfully!',
      errorTitle: 'Error',
      errorDescription: 'Error sending message.',
    },
    sendConfirmationModal: {
      title: 'Send Appointment Confirmation - {{name}}',
      close: 'Close',
      tabs: {
        email: 'Email',
        whatsapp: 'WhatsApp',
      },
      linkCard: {
        title: 'Confirmation Link',
        copy: 'Copy Link',
        copiedTitle: 'Link copied',
        copiedDescription: 'Confirmation link copied to clipboard!',
        expires: 'This link expires in 7 days',
      },
      fields: {
        email: 'Email address',
        emailPlaceholder: 'client@example.com',
        phone: 'Phone number',
        phonePlaceholder: '+55 (11) 99999-9999',
        phoneHelp: 'Use the format: +55 (DDD) 9XXXX-XXXX',
      },
      actions: {
        sendEmail: 'Send Email',
        sendEmailLoading: 'Sending...',
        sendWhatsapp: 'Send WhatsApp',
        sendWhatsappLoading: 'Sending...',
      },
      loading: 'Generating confirmation link...',
      info: 'The client will receive a link to confirm or cancel the appointment. The link expires in 7 days and can only be used once.',
      toast: {
        errorTitle: 'Error',
        successTitle: 'Success',
        tokenError: 'Error generating confirmation token',
        emailRequired: 'Enter an email address',
        emailSent: 'Confirmation email sent successfully!',
        emailError: 'Error sending email',
        phoneRequired: 'Enter a phone number',
        whatsappSent: 'WhatsApp message sent successfully!',
        whatsappError: 'Error sending WhatsApp',
      },
    },
  },
  upload: {
    defaultLabel: 'Upload signature PNG',
  },
} as const;

export default locale;
